import { action, observable } from 'mobx';
import {
    IStoresCoordinates,
    IStoresStringCoordinates,
    IStoresMapBounds,
    IStoresStringMapBounds
} from '~interfaces/IStoresInterfaces';
import { GoogleMap } from '../../../utils/MapsDynamicLoader';

const convertCoordinates = (coord: IStoresStringCoordinates) =>
    coord && { lat: Number(coord.lat), lng: Number(coord.lng) };

export class StoresMap {
    @observable public mapCenter: IStoresCoordinates;
    @observable public mapZoom: number;
    @observable public bounds: IStoresMapBounds;
    @observable public map: GoogleMap;

    @action
    public updateMapCenter(coord: IStoresStringCoordinates) {
        this.mapCenter = convertCoordinates(coord);
    }

    @action
    public updateMapZoom(zoomLevel: string) {
        this.mapZoom = Number(zoomLevel);
    }

    @action
    public convertBounds(bounds: IStoresStringMapBounds) {
        this.bounds = {
            ne: convertCoordinates(bounds.ne),
            sw: convertCoordinates(bounds.sw)
        };
    }

    @action
    public updateBounds(bounds: IStoresMapBounds) {
        this.bounds = bounds;
    }

    @action
    public setMap(map: GoogleMap) {
        this.map = map;
    }
}
